// Stage beyond Pulse: Reels (video posts), Live, Circles (communities) and Collab — read on the web, create in the app.
import { api, qs } from "@/lib/api";

export const liveApi = {
  now: (world) => api(`/live/now?${qs({ world, limit: 30 })}`),
  following: () => api("/live/following"),
  get: (id) => api(`/live/${id}`),
};

export const circlesApi = {
  list: (params) => api(`/communities?${qs(params)}`),
  mine: () => api("/communities/mine"),
  get: (id) => api(`/communities/${id}`),
  members: (id, params) => api(`/communities/${id}/members?${qs(params)}`),
  messages: (id, chid, params) => api(`/communities/${id}/channels/${chid}/messages?${qs(params)}`),
  events: (id) => api(`/communities/${id}/events`),
  join: (id, invite) => api("/communities/" + id + "/join" + (invite ? "?invite=" + encodeURIComponent(invite) : ""), { method: "POST" }),
  leave: (id) => api(`/communities/${id}/leave`, { method: "POST" }),
  create: (body) => api("/communities", { method: "POST", body }),
  send: (id, chid, text) => api("/communities/" + id + "/channels/" + chid + "/messages", { method: "POST", body: { text } }),
  pricing: (id) => api(`/circles/${id}/pricing`),
  joinCheckout: (id, plan, return_base) => api(`/circles/${id}/join/checkout`, { method: "POST", body: { plan, consent: true, return_base } }),
  checkoutStatus: (sid) => api(`/circles/checkout/${encodeURIComponent(sid)}`),
};

export const collabsApi = {
  config: () => api("/collabs/config", { auth: false }),
  list: (params) => api(`/collabs?${qs(params)}`),
  get: (id) => api(`/collabs/${id}`),
  mine: () => api("/collabs/mine"),
  apply: (id, pitch, links = []) => api(`/collabs/${id}/apply`, { method: "POST", body: { pitch, links } }),
};

export const reelsApi = {
  // Video posts come from the explore grid (photo + video posts); we keep the video ones.
  feed: (tab, cursor) => api("/pulse/reels?" + qs({ tab: tab && tab !== "foryou" ? tab : undefined, cursor: cursor || undefined, limit: 8 })),
  page: (page = 0, q) => api(`/stage/explore?${qs({ page, limit: 30, q })}`),
};

export const accessApi = {
  config: () => api("/access/config", { auth: false }),
  browse: (params) => api("/access/offers?" + qs(params || {})),
  mine: () => api("/access/mine"),
};

export const gamifyApi = {
  collabRep: () => api("/gamify/collab/me"),
  collabBoard: (period = "month") => api("/gamify/collab/leaderboard?" + qs({ period })),
  invite: (body) => api("/collabs/invite", { method: "POST", body }),
  invites: () => api("/collabs/invites"),
  respond: (id, accept) => api("/collabs/invites/" + id + "/respond", { method: "POST", body: { accept } }),
};
